import type { MaybeRef } from 'vue';

import type { RequestMeta } from '@/shared/api';

export const databaseKeys = {
  all: ['database'] as const,
  databases: (params: MaybeRef<RequestMeta>) => [...databaseKeys.all, 'databases', params] as const,
  database: (uuid: MaybeRef<string>) => [...databaseKeys.all, 'database', uuid] as const,
  databaseTask: (uuid: MaybeRef<string>) => [...databaseKeys.all, 'database-task', uuid] as const,
  databaseSnapshots: (uuid: MaybeRef<string>) =>
    [...databaseKeys.all, 'database-snapshots', uuid] as const,
  databaseSnapshotTask: (id: MaybeRef<number>) =>
    [...databaseKeys.all, 'database-snapshot-task', id] as const,
  databaseBackups: (uuid: MaybeRef<string>) =>
    [...databaseKeys.all, 'database-backups', uuid] as const,
  databaseFirewallRules: (uuid: MaybeRef<string>) =>
    [...databaseKeys.all, 'database-firewall-rules', uuid] as const,
  databaseSizes: () => [...databaseKeys.all, 'database-sizes'] as const,
  databaseDataForCreate: () => [...databaseKeys.all, 'database-data-for-create'] as const,
  databaseGraphs: (uuid: MaybeRef<string>, graph: MaybeRef<string>) =>
    [...databaseKeys.all, 'database-graphs', uuid, graph] as const,
  databaseFirewallStacklets: (uuid: MaybeRef<string>, query?: MaybeRef<string>) =>
    [...databaseKeys.all, 'database-firewall-stacklets', uuid, ...(query ? [query] : [])] as const,
};
